import React from "react";

/**
 * Reusable section header with industrial accent.
 */
const SectionHeader = ({
  eyebrow,
  title,
  subtitle,
  align = "left",
  invert = false,
}) => {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";
  const eyebrowColor = invert ? "text-[#FF5A00]" : "text-[#FF5A00]";
  const titleColor = invert ? "text-white" : "text-[#111111]";
  const subColor = invert ? "text-white/70" : "text-[#52525B]";

  return (
    <div className={`max-w-3xl ${alignment}`}>
      {eyebrow && (
        <div
          className={`flex items-center gap-3 mb-4 ${
            align === "center" ? "justify-center" : ""
          }`}
        >
          <span className="w-10 h-[2px] bg-[#FF5A00]" />
          <span
            className={`font-mono-rtc text-[11px] uppercase tracking-[0.3em] ${eyebrowColor}`}
          >
            {eyebrow}
          </span>
        </div>
      )}
      <h2
        className={`font-display uppercase font-bold text-2xl sm:text-3xl md:text-4xl ${titleColor}`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${subColor}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
